import React, {useState} from 'react';
import GenericModal from '../../../components/modal/GenericModal';
import AsyncSelectInput from '../../../components/Select/AsyncSelectInput';
import {
    getResponsableEmpleadoAPI, getResponsableEmpleadoWithoutReserverdPeopleWordTypeAPI,
    reasignarSolicitudCondicionAprobacionAPI
} from '../../../consumers/backendApisUrls';
import { useSubmitForm } from '../../../hooks/useSubmitForm/useSubmitForm';

const ReasignarAprobador = ({toggleModal, refreshPage, idCondicion, nombreEmpleado, nombreEmpleadoAprobador}) => {
    const KEYS = ["IdEmpleadoAprobador"];
    const SECTION_NAME = ["ReasignarAprobador"]

    const [selectedAprobador, setSelectedAprobador] = useState();
    
    const [submitForm] = useSubmitForm()

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let api = reasignarSolicitudCondicionAprobacionAPI();
            let payload = getPayload();
            await submitForm(KEYS, api, payload, SECTION_NAME, successReasignarCallback)
        } catch (error) {
            console.error(error);
        }
    }

    const getPayload = () => {
        return {
            IdCondicion: idCondicion,
            IdEmpleadoAprobador: selectedAprobador?.value
        }
    }

    const successReasignarCallback = () => {
        toggleModal();
        refreshPage();
    }

  return (
    <GenericModal showModal={toggleModal} titulo="Reasignar solicitud Licencia" width="600px">
        <div className="modal-body">
            <form>
                <div className="form-row mb-1">
                    <div className="form-group col-sm-12">
                        <label className="modal-label mb-0">Solicitante</label>
                        <input type="text" className="form-control" value={nombreEmpleado ?? ""} disabled/>
                    </div>
                </div>
                <div className="form-row mb-1">
                    <div className="form-group col-sm-12">
                        <label className="modal-label mb-0">Aprobador</label>
                        <input type="text" className="form-control" value={nombreEmpleadoAprobador ?? ""} disabled/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-sm-12">
                        <label className="modal-label mb-0">Nuevo Aprobador</label>
                        <AsyncSelectInput api={getResponsableEmpleadoWithoutReserverdPeopleWordTypeAPI} placeholder="Buscar nuevo aprobador" handleSelectInputChange={(res) => setSelectedAprobador(res)}/>
                        <p className="ficha-form-input-validation-message" id={`ficha-edit-${SECTION_NAME}-IdEmpleadoAprobador-validation-message`}></p>
                    </div>
                </div>
                <div className="modal-footer pl-0">
                    <div>
                    </div>
                    <div>
                    <button type="button" onClick={handleSubmit} className="generic-button-buscador">
                        Guardar
                    </button>
                    </div>
                </div>
            </form>
        </div>
    </GenericModal>
  )
}

export default ReasignarAprobador